import { Injectable } from '@angular/core';
import { HeaderAction } from '@shared/components/header/header.component';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HeaderActionsService {

    private headerAction$ = new BehaviorSubject<HeaderAction[]>([]);
    private menuAction$ = new BehaviorSubject<HeaderAction[]>([]);
    private actions: HeaderAction[] = [];
    private _menuActions: HeaderAction[] = [];

    public get menuActions(): HeaderAction[] {
        return this._menuActions;
    }

    public setMenuActions(menuActions: HeaderAction[]) {
        this.menuAction$.next(menuActions);
        this._menuActions = menuActions;
    }

    public addMenuActions(menuAction: HeaderAction) {
        this._menuActions = [...this._menuActions, menuAction];
        this.menuAction$.next(this._menuActions);
    }

    public setHeaderButton(actions: HeaderAction[]) {
        this.headerAction$.next(actions);
        this.actions = actions;
    }

    public addHeaderButtonAdditional(action: HeaderAction) {
        this.actions = [...this.actions, { ...action, additional: true }];
        this.headerAction$.next(this.actions);
    }

    public addHeaderButton(action: HeaderAction) {
        this.actions = [...this.actions, action];
        this.headerAction$.next(this.actions);
    }

    public clearHeaderActionsAdditional() {
        this.actions = this.actions.filter(({ additional }) => !additional);
        this.headerAction$.next(this.actions);
    }

    public clearHeaderActions() {
        this.actions = [];
        this.headerAction$.next(this.actions);
    }

    public getHeaderActionObservable() {
        return this.headerAction$.asObservable();
    }

    public getMenuActionObservable() {
        return this.menuAction$.asObservable();
    }

}
